import { render } from "./settingindex.vue?vue&type=template&id=3a12a612&scoped=true"
import script from "./settingindex.vue?vue&type=script&lang=js"
export * from "./settingindex.vue?vue&type=script&lang=js"

import "./settingindex.vue?vue&type=style&index=0&id=3a12a612&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a12a612"]])

export default __exports__